module.exports = __webpack_public_path__ + "img/eliminar red.79ff3d8f.svg";